import React, { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RouterRoutesElement } from 'processes';
import { checkOnlineBrowserState } from 'shared/model/connection';
import { globalClass, toastContainerClass } from 'shared/theme/GlobalStyles';
import { endPoints } from 'shared/config/endPoints';
import { renderRoutes } from 'processes/Router/lib/renderRoutes';
import { useMetaThemeColor } from './lib/useMetaThemeColor';
import Modal from 'react-modal';
import { themeModel } from 'shared/theme/model';
import { useGetCookies } from './lib/useGetCookies';
import { OutputFormat, setDefaults } from 'react-geocode';
import { inspect, type Message } from 'effector/inspect';
import { captureMessage } from '@sentry/react';
import { loginRoutes } from 'processes/Router/config/loginRoutes';
import { routes } from 'processes/Router/config/routes';
import { authModel } from 'entities/Auth/model';
import { useInitAuthorizedRequests } from './lib/useInitAuthorizedRequests';
import { Svg } from 'shared/ui/atoms/Svg';
import { showToast } from 'shared/lib/showToast';
import { EToastType } from 'shared/types/toast';
import { ToastContainer } from 'react-toastify';
import { LOCAL_STORAGE_CREDENTIALS } from 'shared/config/constants';
import Cookies from 'js-cookie';

Modal.setAppElement('#root');

setDefaults({
  key: process.env.REACT_APP_GEOCODING_API_KEY,
  language: 'ru',
  outputFormat: OutputFormat.JSON,
});

function logInspectMessage(m: Message) {
  const { name, value } = m;
  if (name === 'failData' && value) {
    console.error('FAIL_DATA', value);
  }
}

inspect({
  fn: (m) => {
    logInspectMessage(m);
  },
});

const App = () => {
  const [activeTheme, token] = useUnit([
    themeModel.stores.$theme,
    authModel.token.stores.$token,
  ]);
  useMetaThemeColor(activeTheme);
  useGetCookies();
  useInitAuthorizedRequests();
  const isLoggedIn = token;

  useEffect(() => {
    checkOnlineBrowserState();
  }, []);

  const onClickToken = () => {
    navigator.clipboard.writeText(
      JSON.stringify({
        token,
        creds: localStorage.getItem(LOCAL_STORAGE_CREDENTIALS),
        session: Cookies.get('click-web-session'),
      }),
    );
    showToast({
      autoClose: 1000,
      toastParams: {
        type: EToastType.Success,
        messageText: 'Token copied',
      },
    });
  };

  return (
    <div className={globalClass}>
      {
        <button
          onClick={onClickToken}
          style={{
            background: 'black',
            position: 'fixed',
            bottom: 100,
            right: 15,
            width: 40,
            height: 40,
            borderRadius: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Svg idIcon="icCheck" width={24} height={24} />
        </button>
      }
      <ToastContainer
        position="bottom-right"
        autoClose={false}
        className={toastContainerClass}
        closeButton={false}
      />
      <BrowserRouter>
        <Routes>
          <Route
            element={<RouterRoutesElement />}
            path={endPoints.DEFAULT_PAGE}>
            {renderRoutes(isLoggedIn ? routes : loginRoutes('123'))}
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
